<template>
  <span :class="{ 'hour-value': true, 'has-border': hasBorder, 'has-padding': hasPadding }">
    {{ hours }}
    <sup>
      {{ minutes }}
    </sup>
  </span>
</template>

<script>
export default {
  name: 'hour',
  props: ['value', 'hasBorder', 'hasPadding'],
  computed: {
    hours () {
      if (!this.value) {
        return '';
      }

      let value = this.value.split(':')[0];

      if (value.length === 1) {
        value = '0' + value;
      }

      return value;
    },
    minutes () {
      if (!this.value) {
        return '';
      }

      return this.value.split(':')[1];
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.hour-value {
  display: inline-block;
  font-size: 2rem;
  font-weight: 500;
  text-align: center;
  position: relative;
  min-width: 6.4rem;

  sup {
    font-size: 1.2rem;
  }

  &.has-padding {
    padding: 0 1rem;
  }

  &.has-border {
    padding: 0 1rem;

    &:after {
      background: $color-button-default-border;
      content: "";
      height: 90%;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Hour.vue